var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFPlayPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Playback Button"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Button",
    cx: 25,
    cy: 25,
    r: 25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons/playback-play"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5551FF",
    id: "Vector",
    d: "M19.8673 14.3028C19.2014 13.8823 18.3333 14.3608 18.3333 15.1483V35.5197C18.3333 36.3072 19.2014 36.7857 19.8673 36.3651L35.9946 26.1795C36.616 25.787 36.616 24.8809 35.9946 24.4885L19.8673 14.3028Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFPlayPurple);
export default __webpack_public_path__ + "static/media/fPlay-purple.b3df3335.svg";
export { ForwardRef as ReactComponent };